import { ComingSoonTypography } from '../styled/styledComponents'

function ComingSoon() {
  return (
    <ComingSoonTypography>Coming soon</ComingSoonTypography>
  )
}

export default ComingSoon
